import { Fab } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import CleanupIcon from "@material-ui/icons/ClearAll";
import KitsCleanupDialog from "./KitsCleanupDialog";
import { useState } from "react";

interface Props {
  buttonClasses: ClassNameMap;
  customerId: number;
  reportAlerts: (messages: string[]) => void;
  refreshKits: () => void;
}

const KitsCleanupButton = (props: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleKitsCleanupButtonClicked = () => {
    setDialogOpen(true);
  };

  const handleCleanupConfirmed = (messages: string[]) => {
    props.reportAlerts(messages);
    setDialogOpen(false);
    props.refreshKits();
  };

  return <>
    <Fab
      aria-label="cleanup"
      className={ props.buttonClasses.button }
      color="primary"
      size="medium"
      onClick={ handleKitsCleanupButtonClicked }
    >
      <CleanupIcon style={ { backgroundColor: 'red', borderRadius: 50, height: 50, width: 50 } } />
    </Fab>
    <KitsCleanupDialog
      customerId={ props.customerId }
      open={ dialogOpen }
      onCleanupConfirmed={ handleCleanupConfirmed }
      onCleanupCanceled={ () => setDialogOpen(false) }
    />
  </>;
}

export default KitsCleanupButton;